// Strips Microsoft Word / Office HTML cruft from pasted content before TipTap/ProseMirror
// parses it, so paste-from-Word doesn't inject mso-* styles, <o:p> tags or Word class names.

export function cleanWordHtml(html) {
    if (!html) return html;
    let cleaned = html;

    // Remove Word's conditional comments and XML blocks (<!--[if ...]>...<![endif]-->, <o:p>, <w:...>).
    cleaned = cleaned.replace(/<!--\[if[\s\S]*?endif\]-->/gi, '');
    cleaned = cleaned.replace(/<\/?o:p>/gi, '');
    cleaned = cleaned.replace(/<\/?w:[^>]*>/gi, '');
    cleaned = cleaned.replace(/<xml>[\s\S]*?<\/xml>/gi, '');

    // Strip mso-* inline style declarations while keeping other legitimate styles.
    cleaned = cleaned.replace(/style="([^"]*)"/gi, (_, styleContent) => {
        const kept = styleContent
            .split(';')
            .filter((decl) => decl.trim() && !/mso-/i.test(decl))
            .join(';');
        return kept ? `style="${kept}"` : '';
    });

    // Drop Word-generated class names (MsoNormal, MsoListParagraph, etc.).
    cleaned = cleaned.replace(/class="[^"]*Mso[^"]*"/gi, '');

    // Remove empty style/class attributes left behind.
    cleaned = cleaned.replace(/\s(style|class)=""/gi, '');

    return cleaned;
}
